import React, { FC } from "react";
import {AppBar, IconButton, Toolbar, useTheme} from "@material-ui/core";
import {ReactComponent as Sun} from "../assets/fontAwesome/sun.svg";
import {ReactComponent as Moon} from "../assets/fontAwesome/moon.svg";

type Props = {
    nightmode: boolean,
    setNightmode: React.Dispatch<boolean>
}

const Navbar: FC<Props> = ({ nightmode, setNightmode }) => {
    const theme = useTheme()

    return(
        <AppBar position={"relative"} style={{position: 'relative', zIndex: 1400, background: 'primary', padding: 0}} elevation={0} className="responsive-toolbar">
            <Toolbar className="responsive-toolbar" style={{padding: 0}} >
                <svg viewBox="0 0 64 42.3" xmlns="http://www.w3.org/2000/svg" style={{fill: "#fff", marginLeft: '12px'}} className="responsive-icon">
                    <path style={{fill: theme.palette.secondary.main}}
                          d="M14.4,36.3c1.1,0,1.9,0.9,1.9,1.9c0,1.1-0.9,1.9-1.9,1.9s-1.9-0.9-1.9-1.9l0,0C12.5,37.2,13.3,36.3,14.4,36.3z"/>
                    <path style={{fill: theme.palette.secondary.main}}
                          d="M16.3,33.4L16.3,33.4l0.1-2.8h-0.1c-5.3,0-9.5,4.3-9.5,9.5h2.8C9.6,36.5,12.6,33.4,16.3,33.4z"/>
                    <path style={{fill: theme.palette.secondary.main}}
                          d="M16.1,28.6h0.2v-2.8h-0.2c-7.9,0-14.3,6.4-14.4,14.3h2.8C4.6,33.8,9.7,28.6,16.1,28.6 C16.1,28.6,16.1,28.6,16.1,28.6z"/>
                    <path
                        d="M38.7,38.9c0,0.4,0,0.9,0.1,1.3h4.3C43,39.7,43,39.3,43,38.9c-0.2-4.1,3.1-7.6,7.2-7.7c4.1-0.2,7.6,3.1,7.7,7.2 c0,0.2,0,0.4,0,0.5c0,0.4,0,0.9-0.1,1.3h4.3c0.1-0.4,0.1-0.9,0.1-1.3c-0.2-6.5-5.6-11.6-12.1-11.4C43.9,27.6,38.9,32.6,38.7,38.9z"/>
                    <path
                        d="M42.3,13.2c3,0,5.5-2.5,5.5-5.5c0.2-3-2.1-5.6-5.2-5.8C39.6,1.6,37,4,36.8,7c0,0.2,0,0.4,0,0.7 C36.8,10.7,39.2,13.2,42.3,13.2C42.3,13.2,42.3,13.2,42.3,13.2z"/>
                    <path
                        d="M21.9,38.9c0,0.4,0,0.9-0.1,1.3h4.3c0.1-0.4,0.1-0.9,0.1-1.3c0-5-3.2-9.5-7.9-11.1v4.7 C20.6,33.8,21.9,36.3,21.9,38.9z"/>
                    <path
                        d="M28.5,32c1.1,1,1.7,2.4,1.5,3.9c0,0.8-0.1,2.5-0.3,4.3h6c0.2-2.9,0.5-5.8,0.6-6.5c0.2-1.4,0.3-2.3-1.7-4.5 s-5.9-7.1-5.9-7.1l4.3-3.9c0,0,3.2,2.8,4.4,3.8c1.8,1.3,3.9,1.9,6.1,1.8h5.9v-4.8h-5.8c-2-0.1-3.8-1.1-5-2.7 c-1.5-1.9-3.4-4.4-4.4-5.6c-1.1-1.4-3.1-1.5-4.7-0.2c-1.4,1.2-4.7,3.9-7.6,6.5c-2.4,2.2-2.6,5.9-0.4,8.4c0.2,0.2,0.3,0.3,0.5,0.5 C23.5,27.2,27.6,31.2,28.5,32z"/>
                </svg>
                <svg viewBox="0 0 150.75 27.68" xmlns="http://www.w3.org/2000/svg" style={{fill: "#fff", marginLeft: '6px'}} className="responsive-icon">
                    <path d="M9.75,25V6.64H2.25v-4h19.2v4h-7.4V25H9.75"/>
                    <path
                        d="M32.85,14.14c4.1,0,4.6-2,4.6-3.5V10c0-1.5-.5-3.4-4.6-3.4h-5.6v7.5ZM37.75,25l-5.5-6.8h-5V25H23V2.64h9.9c5.5,0,8.9,2.7,8.9,7.1v1.4a6.45,6.45,0,0,1-4.6,6.4l6.1,7.5h-5.5"/>
                    <path
                        d="M52.55,16c-4.4,0-4.4,1.6-4.4,2.1v1.1c0,1.5,2.5,2,4.8,2,1.7,0,5.6-.3,5.6-3.1v-1.6a40.47,40.47,0,0,0-6-.5Zm.3,9.4c-5.6,0-9.1-2.3-9.1-5.9v-1.6c0-3.8,3.2-5.8,9-5.8a36.77,36.77,0,0,1,5.8.6V10c0-3.3-3.6-3.7-5.1-3.7-3,0-5,1.1-5,2.8v1.5h-4.3V8.74c0-3.8,3.8-6.5,9.3-6.5s9.4,3,9.4,7.3v9.1c0,4.7-5,6.8-10,6.8"/>
                    <path
                        d="M75.45,25.44c-5.5,0-9.4-3-9.4-7.4V9.54c0-4.4,3.8-7.3,9.4-7.3,5.4,0,9.3,2.7,9.3,6.5v2h-4.3V9.14c0-1.7-2-2.8-5.1-2.8s-5.1,1.4-5.1,3.7v7.7c0,2.3,1.9,3.7,5.1,3.7,3,0,5.1-1.2,5.1-2.9v-1.9h4.3v2.3c0,3.8-3.9,6.5-9.3,6.5"/>
                    <path
                        d="M102.55,11.24V9.74c0-3.2-3.6-3.5-5.2-3.5s-5.2.3-5.2,3.6v1.4Zm-5.2,14.2c-5.7,0-9.5-2.9-9.5-7.2V9.54c0-4.4,3.8-7.3,9.6-7.3s9.5,2.9,9.5,7.3v5.8H92.15v2.6c0,3.2,3.7,3.6,5.2,3.6,2,0,5.2-.4,5.2-3.3v-1.3h4.3v1.6c.1,4.1-3.8,6.9-9.5,6.9"/>
                    <path
                        d="M110.25,25V9.89c0-4.5,3.5-7.3,8.9-7.3h7.1v4.1h-7.1c-3,0-4.6,1.2-4.6,3.7v2h9.1v4h-9.1v8.7h-4.3"/>
                    <path d="M148.75,2.64h-4.7l-5.3,10.9-5.4-10.9h-4.8l7.9,15.5V25h4.3v-6.8l8-15.6"/>
                </svg>
                <IconButton style={{marginLeft: 'auto'}} onClick={() => {
                    if(!nightmode) {
                        window.localStorage.setItem('TracefyTrackingNightmode', 'true')
                    } else {
                        window.localStorage.removeItem('TracefyTrackingNightmode')
                    }
                    setNightmode(!nightmode)
                }}>
                    {!nightmode ? <Moon fill="white" className="responsive-button"/> :
                    <Sun fill="white" className="responsive-button"/>}
                </IconButton>
            </Toolbar>
        </AppBar>)}

export default Navbar;
